enum ItemTypes {
    EVENT = 'EVENT',
}

export {
    ItemTypes
};